import axios from "axios";
import React, { useState, useEffect } from "react";
import { P1, P2, P3 } from "assets/fonts";
import {
  Container,
  Button,
  TextField,
  IconButton,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import Markdown from "markdown-to-jsx";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import AddIcon from "@material-ui/icons/Add";

const TextRandom = (props) => {
  const { id } = props;
  const [sections, setSections] = useState([]);
  const [editingIndex, setEditingIndex] = useState(null);
  const [editingText, setEditingText] = useState("");
  const [deleteIndex, setDeleteIndex] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (id) {
      (async () => {
        try {
          const doc = await axios.get("/api/gui/textrandom/" + id);
          setSections(doc.data.sections || []);
        } catch (error) {
          console.error("Error fetching textrandom data:", error);
          setError("Failed to load text sections");
        }
      })();
    }
  }, [id]);

  useEffect(() => {
    if (sections.length > 0) {
      (async () => {
        try {
          await axios.put("/api/gui/textrandom/" + id, { sections });
        } catch (error) {
          console.error("Error saving textrandom data:", error);
          setError("Failed to save text sections");
        }
      })();
    }
  }, [sections]);

  const handleAddSection = () => {
    setSections([...sections, ""]);
    setEditingIndex(sections.length);
    setEditingText("");
  };

  const handleEditStart = (index) => {
    setEditingIndex(index);
    setEditingText(sections[index]);
  };

  const handleEditSave = () => {
    if (!editingText.trim()) {
      setError("Text section cannot be empty");
      return;
    }
    const newSections = [...sections];
    newSections[editingIndex] = editingText;
    setSections(newSections);
    setEditingIndex(null);
    setEditingText("");
    setError(null);
  };

  const handleDelete = (index) => {
    setDeleteIndex(index);
  };

  const confirmDelete = () => {
    const newSections = sections.filter((_, i) => i !== deleteIndex);
    setSections(newSections);
    setDeleteIndex(null);
  };

  const handleCancelEdit = () => {
    setEditingIndex(null);
    setEditingText("");
    setError(null);
  };

  return (
    <Container id="texts">
      <P1>Text Randomization</P1>
      <P3>
        (You can add multiple text sections in markdown format. Each section has
        an equal chance of being displayed to users.)
      </P3>
      {error && (
        <div style={{ color: "red", margin: "10px 0" }}>
          <P3>{error}</P3>
        </div>
      )}
      <br />
      <div id="text-section">
        {sections.map((section, i) => {
          return (
            <div key={i} style={{ marginBottom: "20px" }}>
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "10px",
                }}
              >
                <P2 style={{ flex: 1 }}>Section {i + 1}</P2>
                <IconButton
                  size="small"
                  onClick={() => handleEditStart(i)}
                  style={{ marginRight: "8px" }}
                >
                  <EditIcon />
                </IconButton>
                <IconButton
                  size="small"
                  onClick={() => handleDelete(i)}
                  color="secondary"
                >
                  <DeleteIcon />
                </IconButton>
              </div>
              {editingIndex === i ? (
                <div>
                  <TextField
                    fullWidth
                    multiline
                    rows={4}
                    value={editingText}
                    onChange={(e) => setEditingText(e.target.value)}
                    variant="outlined"
                    error={!!error}
                    helperText={error}
                  />
                  <div style={{ marginTop: "10px" }}>
                    <Button
                      size="small"
                      color="primary"
                      variant="contained"
                      onClick={handleEditSave}
                      style={{ marginRight: "8px" }}
                    >
                      Save
                    </Button>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={handleCancelEdit}
                    >
                      Cancel
                    </Button>
                  </div>
                </div>
              ) : (
                <div>
                  <div
                    style={{
                      border: "1px solid #ccc",
                      padding: "10px",
                      marginBottom: "10px",
                      backgroundColor: "#f9f9f9",
                    }}
                  >
                    <Markdown>{section}</Markdown>
                  </div>
                </div>
              )}
            </div>
          );
        })}
        <Button
          color="primary"
          variant="contained"
          onClick={handleAddSection}
          startIcon={<AddIcon />}
          style={{ marginTop: "10px" }}
        >
          Add section
        </Button>
      </div>

      <Dialog open={deleteIndex !== null} onClose={() => setDeleteIndex(null)}>
        <DialogTitle>Delete Section</DialogTitle>
        <DialogContent>
          <P3>Are you sure you want to delete this section?</P3>
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setDeleteIndex(null)} color="primary">
            Cancel
          </Button>
          <Button onClick={confirmDelete} color="secondary" autoFocus>
            Delete
          </Button>
        </DialogActions>
      </Dialog>
    </Container>
  );
};

export default TextRandom;
